<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;"></span>
          </template>
        </Head>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="16">
        <el-card class="box-card">
          <div class="text item">
            <el-row>
              <el-col :span="5">
                <el-input
                    placeholder="请输入手机号码"
                    prefix-icon="el-icon-search"
                    v-model="phone">
                </el-input>
              </el-col>
              <el-col :span="19">
                <el-button type="primary theme-btn" class="btn" @click.native="searchClick">查询</el-button>
                <el-button type="info" class="btn" @click.native="rest">重置</el-button>
              </el-col>
            </el-row>

            <!-- 表格 -->
            <el-table style="width: 100%" :data="tableData" class="table-content">
              <el-table-column label="编号" show-overflow-tooltip prop="id"></el-table-column>
              <el-table-column label="用户名" show-overflow-tooltip align="center" prop="userName"
                               width="100"></el-table-column>
              <el-table-column label="公司名称" align="center" show-overflow-tooltip prop="companyName"></el-table-column>
              <el-table-column label="类型" align="center" prop="identityStatus"
                               :formatter="identityStatusData"></el-table-column>
              <el-table-column label="联系电话" show-overflow-tooltip align="center" prop="phone" width="110">
                <template slot-scope="scope">
                  <el-input
                      v-if="scope.row.checkInp"
                      v-model="scope.row.phone"
                      style="width:80%;"
                      @mouseout.native="scope.row.checkInp=false">
                  </el-input>
                  <span v-else @click="scope.row.checkInp=true">{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column label="用户状态" align="center" :formatter="blockText" prop="status"></el-table-column>
              <el-table-column label="操作" align="center" width="180" type="index">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" v-if="scope.row.identityStatus!=0" @click="isLeaveFun(scope)"
                             class="table-del">离开公司
                  </el-button>
                  <el-button size="mini" v-if="scope.row.status == 1" type="danger" @click="block(scope.row,2)">拉黑
                  </el-button>
                  <el-button size="mini" v-if="scope.row.status == 2" type="primary" @click="Enable(scope.row,1)">启用
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="pagelist" style="text-align: center" v-if="pagegtion">
            <el-row type="flex" justify="center">
              <el-col :span="24" class="nomore" style="margin-top:24px;">
                <el-pagination
                    class="page"
                    background
                    :current-page="currentPage"
                    @current-change="current_page"
                    layout="total, prev, pager, next, jumper"
                    :total="dataNumber">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-card>

      </el-col>
    </el-row>

    <!-- 离开公司弹框 -->
    <el-dialog
        width="15%"
        :visible.sync="isLeave"
        :show-close="false"
        class="warning">
      <p class="font">确认离开{{ rowInfo.companyName }}</p>
      <p slot="footer" class="dialog-footer">
        <el-button @click="deleteRow(0)" class="refuse">拒 绝</el-button>
        <el-button @click="deleteRow(1)" class="confirm">同 意</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import Head from '@/components/header/head.vue';

export default {
  components: {
    Head
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      dataNumber: 0,
      search: '',
      phone: '',  // 电话
      // 离开公司弹框数据
      companyName: '',
      isLeave: false,     // 离开公司
      // 离开公司传送数据（传输当前行的索引）
      rowInfo: '',
      pagegtion: true,
      page: 1,
      size: 10,
    }
  },

  mounted() {
    this.searchFn(this.page, this.size, this.phone)
  },
  methods: {
    rest() {
      this.phone = ""
      this.currentPage = 1
      this.pagegtion = false
      this.$nextTick(() => {
        this.pagegtion = true
      })
      this.searchFn(1, this.size, '')
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage
      this.searchFn(this.page, this.size, this.phone)
    },
    // 启用
    Enable(val, status) {
      this.$confirm('此操作将启用该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '启用成功!'
        });
        this.axiosPost('/web/user/update', {
          id: val.id,
          status: status,
        }).then((res) => {
          if (res.code == 200) {
            this.searchFn(this.page, this.size, '')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消启用'
        });
      });


    },
    // 拉黑人员
    block(val, status) {
      this.$confirm('此操作将拉黑该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axiosPost('/web/user/update', {
          id: val.id,
          status: status,
        }).then((res) => {
          if (res.code == 200) {
            this.searchFn(this.page, this.size, '')

          }
        })
        this.$message({
          type: 'success',
          message: '拉黑成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消拉黑'
        });
      });


    },
    // 数字转换文字
    blockText(row, column) {
      if (row.status == 2) {
        return '拉黑'
      } else {
        return '启用'
      }
    },
    // 类型
    identityStatusData(val) {
      if (val.identityStatus == 0) {
        return '个人端'
      } else {
        return '企业端'
      }
    },
    // 用户搜索
    searchClick() {
      this.searchFn(this.page, this.size, this.phone)
    },
    // 数据调用
    searchFn(page, size, phone) {
      this.axiosGet(`/web/user/page/${page}/${size}`, {
        params: {
          phone: phone
        }
      }).then((res) => {
        if (res.code == 200) {
          res.data.list.forEach((item) => {
            item.checkInp = false
          })
          this.tableData = res.data.list
          this.dataNumber = res.data.total
        }
      })
    },
    // 离开公司弹框拒绝/同意函数
    deleteRow(flag) {  // 0.拒绝    1.同意
      if (flag == '1') {
        this.axiosPost(`/web/user/relieveCompanyStatus`, {
              id: this.rowInfo.id
            }
        ).then((res) => {
          this.$message.success('解除成功')
          this.searchFn(1, 10, '')
        })
      }
      // flag == '1'? this.tableData.splice(this.rowInfo.$index,1) : '';
      this.isLeave = false
    },
    // 离开公司按钮
    isLeaveFun(row) {
      this.isLeave = true
      this.rowInfo = row.row
    }
  },

}
</script>
<style lang="less" scoped>
.btn {
  width: 96px;
  height: 42px;
  margin-left: 43px;
}

.table-compile {
  background-color: #1A80FC;
  width: 72px;
  height: 30px;
  color: #ffffff;
}

.table-del {
  width: 72px;
  height: 30px;
  background: #D1E6FF;
  color: #1A80FC;
  border-color: #D1E6FF;
}

// 弹框
.alertBtn {
  height: 30px;
  line-height: 6px;
}

.compile {
  color: #ffffff;
}

.del {
  color: #1A80FC;
}


// 离开公司弹框
.warning {
  .font {
    text-align: center;
  }

  .dialog-footer {
    border-top: solid #999999 1px;
    height: 50px;
  }
}

.refuse, .confirm {
  width: 50%;
  height: 100%;
  border: none;
  margin-left: 0;
  border-radius: 0;
}

.confirm {
  color: #1A80FC;
}
</style>
